import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import MainLayout from '../../components/MainLayout';
import { fetchFactories } from '../../services/api';
import './Home.css';

function Home() {
  const navigate = useNavigate();
  const [factoryData, setFactoryData] = useState([]);
  const [loading, setLoading] = useState(true);

  // API에서 공장 목록 가져오기
  useEffect(() => {
    const loadFactories = async () => {
      try {
        setLoading(true);
        const data = await fetchFactories();

        // API 데이터 사용 (사출기 통계 포함)
        const factories = Array.isArray(data) ? data : [];
        const factoriesWithMachines = factories.map(factory => ({
          id: factory.id,
          name: factory.factoryName,
          location: factory.address,
          running: factory.runningEquipment || 0,
          idle: factory.idleEquipment || 0,
          stopped: factory.stoppedEquipment || 0,
          total: factory.totalEquipment || 0
        }));

        setFactoryData(factoriesWithMachines);
      } catch (err) {
        console.error('공장 목록 조회 실패:', err);
        // 에러 시 빈 배열
        setFactoryData([]);
      } finally {
        setLoading(false);
      }
    };

    loadFactories();
  }, []);

  // 사출기 상태 그리드 컴포넌트
  const MachineStatusGrid = ({ running, idle, stopped, total }) => {
    return (
      <div className="machine-status-grid">
        <div className="status-item status-total">
          <div className="status-label">총 사출기</div>
          <div className="status-value">{total}</div>
        </div>
        <div className="status-item status-running">
          <div className="status-label">가동중</div>
          <div className="status-value">{running}</div>
        </div>
        <div className="status-item status-idle">
          <div className="status-label">대기</div>
          <div className="status-value">{idle}</div>
        </div>
        <div className="status-item status-stopped">
          <div className="status-label">정지</div>
          <div className="status-value">{stopped}</div>
        </div>
      </div>
    );
  };

  return (
    <MainLayout>
        <div className="home-header" onClick={() => navigate('/enterprise')}>
          <div className="home-title">전사모니터링</div>
        </div>

        <div className="background-image" style={{backgroundImage: `url(${process.env.PUBLIC_URL}/factory-aerial.png)`}}>
          {loading ? (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '400px', color: 'white' }}>
              데이터를 불러오는 중...
            </div>
          ) : factoryData.length === 0 ? (
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '400px', color: 'white', gap: '16px' }}>
              <div style={{ fontSize: '18px' }}>등록된 공장이 없습니다</div>
              <div style={{ fontSize: '14px', opacity: 0.7 }}>시스템 관리 메뉴에서 공장을 먼저 등록해주세요</div>
            </div>
          ) : (
            factoryData.map((factory) => (
              <div
                key={factory.id}
                className={`factory-marker factory-${factory.id}`}
                onClick={() => navigate(`/factory?factoryId=${factory.id}`)}
              >
                <div className="factory-marker-content">
                  <div className="factory-info-left">
                    <div className="factory-marker-name">{factory.name}</div>
                    <div className="factory-marker-location">{factory.location}</div>
                  </div>
                  <div className="factory-divider"></div>
                  <MachineStatusGrid
                    running={factory.running}
                    idle={factory.idle}
                    stopped={factory.stopped}
                    total={factory.total}
                  />
                </div>
                <div className="factory-marker-arrow">
                  <svg width="2" height="80" viewBox="0 0 2 80">
                    <line x1="1" y1="0" x2="1" y2="80" stroke="#5a6d8d" strokeWidth="2"/>
                  </svg>
                  <div className="factory-marker-dot"></div>
                </div>
              </div>
            ))
          )}
        </div>
    </MainLayout>
  );
}

export default Home;
